import React from "react";

const Carousel = () => {
  return (
    <div id="carouselExample" className="carousel slide">
      <div className="carousel-inner">
      
        <div className="carousel-item active">
          <img
            className="bd-placeholder-img bd-placeholder-img-lg d-block w-100"
            src="/img/carousel/g1.jpg"
            alt="image1"
            width="100%"
            height="600"
          />
        </div>
        <div className="carousel-item">
          <img
            className="bd-placeholder-img bd-placeholder-img-lg d-block w-100"
            src="/img/carousel/g2.jpg"
            alt="image2"
            width="100%"
            height="600"
          />
        </div>
        <div className="carousel-item">
          <img
            className="bd-placeholder-img bd-placeholder-img-lg d-block w-100"
            src="/img/carousel/g3.jpg"
            alt="image3"
            width="100%"
            height="600"
          />
        </div>
        <div className="carousel-item">
          <img
            className="bd-placeholder-img bd-placeholder-img-lg d-block w-100"
            src="/img/carousel/g4.jpg"
            alt="image3"
            width="100%"
            height="600"
          />
        </div>
        <div className="carousel-item">
          <img
            className="bd-placeholder-img bd-placeholder-img-lg d-block w-100"
            src="/img/carousel/g5.jpg"
            alt="image3"
            width="100%"
            height="600"
          />
        </div>
        <div className="carousel-item">
          <img
            className="bd-placeholder-img bd-placeholder-img-lg d-block w-100"
            src="/img/carousel/g6.jpg"
            alt="image3"
            width="100%"
            height="500"
          />
        </div>
      </div>

      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target="#carouselExample"
        data-bs-slide="prev"
      >
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Previous</span>
      </button>
      <button
        className="carousel-control-next"
        type="button"
        data-bs-target="#carouselExample"
        data-bs-slide="next"
      >
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="visually-hidden">Next</span>
      </button>
    </div>
  );
};

export default Carousel;
